import { useMediaQuery as useMediaQueryResponsive } from 'react-responsive'
import { useThemeUI } from 'theme-ui'

type Props = {
  query: (breakpoints: string[]) => string
}

const useMediaQuery = ({ query }: Props) => {
  const theme = useThemeUI()
  const breakpoints = theme.theme.breakpoints as string[]
  const resolveQuery = query(breakpoints)
  return useMediaQueryResponsive({ query: resolveQuery })
}

export default useMediaQuery
